import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ApiService } from '../../core/api.service';
import { endPoints } from '../../core/Apis/apiEndpoints';
import { ServiceService } from '../../service.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-employee-attendence-details',
  templateUrl: './employee-attendence-details.component.html',
  styleUrls: ['./employee-attendence-details.component.css']
})
export class EmployeeAttendenceDetailsComponent implements OnInit {

  attendanceList: any[] = [];
  employeeDropdown: any[] = [];
  departmentDropdown: any[] = [];

  // Stats
  attendancePercentage: number = 0;
  absentPercentage: number = 0;
  fullDayCount: number = 0;
  absentCount: number = 0;

  // Filters

  formattedDate = ''


  isFactoryManager: boolean = false;
  filterForm: FormGroup

  constructor(
    private apiService: ServiceService,
    private methodService: ApiService,
    private fb: FormBuilder,
    private router: ActivatedRoute
  ) {
    this.filterForm = this.fb.group({
      selectedEmployee: [""],
      selectedDepartment: [""],
    });
  }

  ngOnInit(): void {
    this.router.queryParams.subscribe({
      next: (params) => {
        if (params['id']) {
          this.filterForm.controls['selectedEmployee'].setValue(params['id']);
          this.formattedDate = params['date'] || '';
          this.isFactoryManager = localStorage.getItem('userTypecon')?.toUpperCase() === 'FACTORY_MANAGER';
          this.fetchEmployees();
          this.fetchDepartments();
          this.fetchReportData();
        }
      },
      error: (err) => console.error('Error fetching query params:', err)
    })

  }

  // Date handling


  // Data fetching methods
  fetchEmployees(searchValue?: string): void {


    if (this.isFactoryManager) {
      this.filterForm.controls['selectedDepartment'].setValue('UMM AL QUWAIN FACTORY');
    }

    this.apiService.ViewAllEmployeefilter(`?department=${this.filterForm.controls['selectedDepartment'].value}`).subscribe({
      next: (response) => this.employeeDropdown = response.data,
      error: (err) => console.error('Error fetching employees:', err)
    });
  }

  fetchDepartments(): void {
    this.apiService.departmentDropdown().subscribe({
      next: (response) => this.departmentDropdown = response.data,
      error: (err) => console.error('Error fetching departments:', err)
    });
  }

  fetchReportData(): void {
    const employeeId = this.filterForm.controls['selectedEmployee'].value || localStorage.getItem('admin_id');
    const params = `?employee_id=${employeeId}&month_filter=${this.formattedDate}`;

    this.methodService.get(endPoints.viewEmployeeAttendance + '/employee_list/admin', params).subscribe({
      next: (response) => {
        this.attendanceList = response.data || [];
        this.calculateAttendanceStats();
      },
      error: (err) => console.error('Error fetching attendance:', err)
    });
  }

  // Filter handlers
  onDepartmentChange(event: any): void {
    if (event) {
      this.fetchEmployees(event?.department_name);
    } else {
      this.filterForm.controls['selectedEmployee'].setValue('');
      this.fetchReportData();
    }
  }

  onEmployeeChange(event: any): void {
    this.fetchReportData();
  }

  // Stats calculation
  sickLeaveCount:number = 0;
  localLeaveCount:number = 0;
  vacationCount:number = 0;
  calculateAttendanceStats(): void {
    if (!this.attendanceList.length) {
      this.resetStats();
      return;
    }

    
    this.sickLeaveCount = this.attendanceList.filter(item => 
      item.leave_type?.toLowerCase() === 'sick leave').length;

    this.localLeaveCount = this.attendanceList.filter(item =>
      item.leave_type?.toLowerCase() === 'local leave').length;

    this.vacationCount = this.attendanceList.filter(item =>
      item.leave_type?.toLowerCase() === 'vacation').length;



    const totalDays = this.attendanceList.length;
    this.fullDayCount = this.attendanceList.filter(item =>
      item.attendance_status?.toLowerCase() === 'present').length;

    this.absentCount = this.attendanceList.filter(item =>
      item.attendance_status?.toLowerCase() === 'absent').length;

    this.attendancePercentage = Math.round((this.fullDayCount / totalDays) * 100);
    this.absentPercentage = Math.round((this.absentCount / totalDays) * 100);
  }

  private resetStats(): void {
    this.attendancePercentage = 0;
    this.absentPercentage = 0;
    this.fullDayCount = 0;
    this.absentCount = 0;
  }
}
